import type { User } from 'firebase/auth'
import { useContext } from 'react'

import { AuthContext } from '@/context/authContext'

interface AuthenticatedUserHook {
  isLoading: boolean
  authenticatedUser: User | null
}

/**
 * A custom hook that provides the authenticated user object and its loading status.
 * The user object is only available once the authentication state is no longer loading.
 */
export const useAuthInfo = (): AuthenticatedUserHook => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuthActions must be used within an AuthProvider')
  }

  const { authState } = context

  const authenticatedUser = authState.isLoading ? null : authState.user

  return {
    isLoading: authState.isLoading,
    authenticatedUser,
  }
}
